import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

interface RouteStore {
  stack: string[]
  isGoingBack: boolean
  setIsGoingBack: (val: boolean) => void
  pushPath: (path: string) => void
  popPath: (locale: string) => string | undefined
}

const excludePathList = ["/sign-in", "/sign-up", "/error", "/not-found"]

export const useRouteStore = create<RouteStore>()(
  persist(
    (set, get) => ({
      stack: [],
      isGoingBack: false,
      setIsGoingBack: (val: boolean) => set({ isGoingBack: val }),
      pushPath: (path: string) => {
        const savePath = '/' + path.split("/").slice(2).join("/")
        const isExcluded = excludePathList.some(path =>
          savePath.startsWith(path)
        )
        if (isExcluded) {
          return
        }
        const stack = get().stack
        const lastPathname = stack[stack.length - 1]?.split('?')[0]
        const newPathname = savePath.split('?')[0]

        if (lastPathname === newPathname) {
          set({ stack: [...stack.slice(0, -1), savePath] })
        } else {
          set({ stack: [...stack, savePath] })
        }
      },
      popPath: (locale: string) => {
        const stack = [...get().stack]
        const prev = stack.pop()
        set({ stack })
        return prev ? `/${locale}/${prev}` : ''
      },
    }),
    {
      name: 'ROUTE_STACK',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ stack: state.stack }),
    }
  )
)